import { memo } from 'react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { SkeletonLoader } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';

interface Props {
    label: string;
    value?: React.ReactNode;
    isLoading?: boolean;
    isClickable?: boolean;
    onClick?: (e: React.MouseEvent<HTMLParagraphElement>) => void;
}

const CJInfoBlockLabelValueWrapper: React.FC<Props> = ({ label, value, isLoading, isClickable, onClick }) => {
    const { t } = useTranslation();

    return (
        <div className={'cj-info-label-value-wrapper'}>
            <p className={'cj-info-label-value-wrapper_label'}>{label}</p>
            <SkeletonLoader isBusy={isLoading}>
                <p className={`cj-info-label-value-wrapper_value ${isClickable && 'cj-info-value'}`} onClick={onClick}>
                    {isNil(value) ? t(l.NA) : value}
                </p>
            </SkeletonLoader>
        </div>
    );
};

export default memo(CJInfoBlockLabelValueWrapper);
